// 发票类型
export enum InvoiceType {
    '专票' = 1,
    '普票',
    '无票',
    '其他'
}